import React from 'react';
import NextLink from 'next/link';
import Image from 'next/image';

import {
  CONTENT_OPTION_MENU,
  LIST_OPTION_MENU,
  MAIS_RETORNO_MENU,
  TOOLS_OPTION_MENU,
} from '../../../navbar/constants/menu-options.constant';
import { SocialNetWorks } from '../../../social-networks';

export const FooterNavLinks = () => {
  const FOOTER_LINKS = [
    LIST_OPTION_MENU,
    TOOLS_OPTION_MENU,
    CONTENT_OPTION_MENU,
    MAIS_RETORNO_MENU,
  ];

  return (
    <div className="flex flex-row flex-wrap gap-3">
      <div className="flex flex-col gap-8 mb-4">
        <Image
          src="/img/logo-principal.svg"
          alt="Logo Mais Retorno"
          title="Logo Mais Retorno"
          width={150}
          height={50}
        />

        <div className="ml-2">
          <SocialNetWorks iconSize={30} />
        </div>
      </div>

      {FOOTER_LINKS.map((group) => (
        <div key={group.title} className="px-4 md:px-8">
          <p className="text-text-light text-sm mb-3">{group.title}</p>

          <ul className="p-0">
            {group.items.map((tool) => (
              <li
                key={`footer-${tool.link}`}
                title={tool.label}
                className="my-2 text-sm"
              >
                <NextLink
                  href={tool.link}
                  prefetch={false}
                  className="text-white hover:underline hover:text-primary"
                >
                  {tool.label}
                </NextLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};
